import { mountComponentWithDataProps } from 'javascripts/shared/utils/react_mount';

import { BookClubHeaderImageSection } from 'javascripts/components/book_club/book_club_header_image_section';

mountComponentWithDataProps('#book-club-header-image-section', BookClubHeaderImageSection);
